<template>
  <a-card :bordered="false" style="height: 100%;">
    <div style="width: 100%;height: 100%;display: flex;">
      <div class="chatList-left">
        <div class="searchtop">
          <span style="font-size:18px;font-weight:800;">聊天列表</span>
          <a-input-search
            placeholder="请输入关键字"
            enter-button="搜索"
            @search="onSearchGroup"
            v-model="condition"
          />
        </div>
        <div class="list-content">
          <div
            v-if="dataSource != undefined && dataSource.length === 0"
            class="nullchat"
          >
            <span>暂无相关记录</span>
          </div>
          <div style="marginLeft:50%;marginTop:50%;" v-if="isSearching">
            <a-spin />
          </div>
          <ul
            v-if="
              dataSource != undefined && dataSource.length > 0 && !isSearching
            "
          >
            <li
              v-for="(item, index) in dataSource"
              :key="index"
              @click="chatinfoDetails(item, index)"
              :class="isactive == index ? 'active' : ''"
            >
              <img src="../../../assets/chatroom.jpg" alt="" />
              <div>
                <p class="username" v-if="item.roomId">
                  {{ item.roomName || item.ownerName + '的群' }}
                </p>
                <p class="username" v-if="!item.roomId">
                  {{
                    item.title.replace('null', '未知用户') ||
                      item.roomName ||
                      item.ownerName + '的群'
                  }}
                </p>
                <span v-if="item.lastMsg">{{
                  item.lastMsg.content ? item.lastMsg.content : '无内容'
                }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div style="text-align:center;margin:10px 0" v-if="isLoad">
          <a-pagination
            size="small"
            :total="ipagination.total"
            @change="change"
            :pagination="ipagination"
            :loading="loading"
          />
        </div>
        <div style="text-align:center;margin:10px 0" v-else>
          <a-pagination
            size="small"
            :total="ipagination.total"
            @change="changeGroupList"
            :pagination="ipagination"
            :loading="loading"
          />
        </div>
      </div>
      <div class="chatList-right">
        <div class="headerOfuser">
          <p style="line-height:30px;font-size:18px;">
            <b
              >{{ msgfrom }}
              <template v-if="chattotal > 0">({{ chattotal }})</template></b
            >
          </p>
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-input placeholder="请输入聊天记录查询" v-model="searchInfo" />
            </a-col>
            <a-col :md="10" :sm="12">
              <span class="demonstration" style="margin:0 20px;"
                >会话日期:</span
              >
              <a-range-picker
                v-model="conditionDate"
                @change="changeTime"
                style="width:60%"
              ></a-range-picker>
            </a-col>
            <a-col :md="6" :sm="8">
              <a-button
                type="primary"
                style="margin-right:10px;"
                @click="searchQuery"
              >
                查询
              </a-button>
              <a-button @click="messageReset">
                重置
              </a-button>
            </a-col>
          </a-row>
        </div>

        <a-tabs default-active-key="1" @change="tabChange" v-model="activeKey">
          <a-tab-pane key="1" tab="全部">
            <div
              :class="'message ' + (!msgContent ? 'no-em-css' : '')"
              @scroll="upScrollFn"
              id="message"
            >
              <template v-if="chatInfo !== undefined && chatInfo.length !== 0">
                <div
                  v-for="(item, index) in chatInfo"
                  :key="index"
                  :class="msgcurrent(item.fromUserId)"
                >
                  <img v-if="item.headUrl" :src="item.headUrl" alt="" />
                  <img v-else src="../image/user.jpg" alt="" />

                  <b style="position: absolute;"
                    >{{ item.name }}
                    <i style="font-size:12px;font-style:normal">{{
                      timestampToTime(item.msgtime)
                    }}</i></b
                  >
                  <div class="content">
                    <div v-if="item.msgtype === 'image'">
                      <img
                        v-if="item.mediaStatus == 3"
                        :src="baseurl + item.sdkfileid"
                        style="width:200px;height:auto;border-radius:0;"
                      />
                      <span v-else>[图片]</span>
                    </div>
                    <div v-else-if="item.msgtype === 'voice'">
                      {{ item.mediaStatus }}
                      <audio v-if="item.mediaStatus == 3" controls>
                        <source
                          :src="baseurl + item.sdkfileid"
                          type="audio/ogg"
                        />
                        Your browser does not support the audio element.
                      </audio>
                      <span v-else>[语音]</span>
                    </div>

                    <div v-else-if="item.msgtype === 'file'">
                      <a
                        v-if="item.mediaStatus == 3"
                        :href="baseurl + item.sdkfileid"
                      >
                        {{ item.filename }}
                      </a>
                      <span v-else>[文件]</span>
                    </div>

                    <div v-else-if="item.msgtype === 'emotion'">
                      <image
                        v-if="item.mediaStatus == 3"
                        :src="baseurl + item.sdkfileid"
                      >
                        {{ item.filename }}
                      </image>
                      <span v-else>[表情]</span>
                    </div>

                    <div v-else-if="item.msgtype === 'weapp'">
                      <span>[小程序]</span>
                    </div>

                    <div v-else-if="item.msgtype === 'link'">
                      <span>[链接]</span>
                    </div>
                    <div v-else-if="item.msgtype === 'video'">
                      <video controls="controls" width="60%">
                        <source
                          :src="baseurl + item.sdkfileid"
                          type="video/mp4"
                        />
                        您的浏览器不支持 video 标签。
                      </video>
                    </div>

                    <span
                      v-else
                      @click="scoreView(item.content, index)"
                      v-html="item.content || '未识别'"
                    >
                    </span>
                  </div>

                  <em v-if="activeScore === index">
                    当前评分:&nbsp;{{ score }}分
                    <b style="font-size:14px;"
                      >{{ sensitive }} {{ sentiment }}</b
                    >
                  </em>
                </div>
              </template>
              <a-empty style="margin-top:100px;" v-if="chatInfo.length == 0" />
              <a-spin v-if="loadshow && chatInfo.length == 0" />
              <div
                style="font-size:14px;text-align:center;line-height:100px;"
                v-if="noData && chatInfo.length != 0"
              >
                没有更多数据了！
              </div>
            </div>
            <!-- <div class="aboutChatmsg" v-if="!aboutChatmsgshow">
              <div class="aboutList" id="aboutChatMessage" @scroll="onScrollSearch"
                style="height: 640px;overflow:scroll">
                <ul style="padding-inline-start:0;">
                  <a-empty style="margin-top:100px;" v-if='chatInfo.length==0' />
                  <li v-for="(item,index) in chatInfo" :key="index" @click="goSearch(item.msgid)">
                    <img v-if="item.headUrl" :src="item.headUrl" alt="" />
                    <img v-else src="../image/user.jpg" alt="" />

                    <b>{{ item.name }}
                      <i style="font-size:12px;font-style:normal">{{ timestampToTime(item.msgtime) }}</i></b>
                    <p style="margin-top:5px;">
                      {{ item.content }}
                    </p>
                  </li>
                </ul>
              </div>
            </div> -->
          </a-tab-pane>
          <a-tab-pane key="2" tab="文件" force-render>
            <div
              class="filecontainer"
              v-if="fileData != undefined && fileData.length != 0"
            >
              <div
                v-for="(item, index) in fileData"
                :key="index"
                :class="msgcurrent(item.fromUserId)"
              >
                <img
                  v-if="item.headUrl"
                  :src="item.headUrl"
                  alt=""
                  class="touxiang"
                />
                <img v-else src="../image/user.jpg" alt="" class="touxiang" />
                <b style="position: absolute;"
                  >{{ item.name }}
                  <i style="font-size:12px;font-style:normal">{{
                    timestampToTime(item.msgtime)
                  }}</i></b
                >
                <div class="content" style="margin-top:30px">
                  <a :href="baseurl + item.sdkfileid">
                    {{ item.filename }}
                  </a>
                </div>
              </div>
            </div>
            <div
              v-else
              class="filecontainer"
              style="text-align:center;line-height:400px;font-size:16px;"
            >
              <a-empty style="margin-top:100px;" />
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="图片与视频">
            <div
              class="imgcontainer"
              v-if="imgData != undefined && imgData.length != 0"
            >
              <div
                v-for="(item, index) in imgData"
                :key="index"
                :class="msgcurrent(item.fromUserId)"
              >
                <img
                  v-if="item.headUrl"
                  :src="item.headUrl"
                  alt=""
                  class="touxiang"
                />
                <img v-else src="../image/user.jpg" alt="" class="touxiang" />
                <b style="position: absolute;"
                  >{{ item.name }}
                  <i style="font-size:12px;font-style:normal">{{
                    timestampToTime(item.msgtime)
                  }}</i></b
                >
                <div class="content" style="margin-top:30px">
                  <div v-if="item.msgtype === 'video'">
                    <video controls="controls" width="60%">
                      <source
                        :src="baseurl + item.sdkfileid"
                        type="video/mp4"
                      />
                      您的浏览器不支持 video 标签。
                    </video>
                  </div>
                  <div v-else>
                    <img
                      :src="baseurl + item.sdkfileid"
                      width="400"
                      alt=""
                      style="width:200px;height:auto;border-radius:0;"
                    />
                    <!-- <p style="margin:20px;">发送人:<span>{{ item.extUserName }}</span></p>
                    <p style="margin:20px;">发送时间:{{ timestampToTime(item.msgtime) }}</p> -->
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="filecontainer"
              style="text-align:center;line-height:400px;font-size:16px;"
            >
              <a-empty style="margin-top:100px;" />
            </div>
          </a-tab-pane>
          <a-tab-pane key="4" tab="链接">
            <div
              class="filecontainer"
              v-if="urlData != undefined && urlData.length != 0"
            >
              <div
                v-for="(item, index) in urlData"
                :key="index"
                :class="msgcurrent(item.fromUserId)"
              >
                <img
                  v-if="item.headUrl"
                  :src="item.headUrl"
                  alt=""
                  class="touxiang"
                />
                <img v-else src="../image/user.jpg" alt="" class="touxiang" />
                <b style="position: absolute;"
                  >{{ item.name }}
                  <i style="font-size:12px;font-style:normal">{{
                    timestampToTime(item.msgtime)
                  }}</i></b
                >
                <div class="content" style="margin-top:30px">
                  <p>
                    <a-icon type="link" style="font-size:20px;" />
                    <a
                      :href="item.link_url"
                      target="_blank"
                      style="margin-left:20px;"
                      >{{ item.title }}</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div
              v-else
              class="filecontainer"
              style="text-align:center;line-height:400px;font-size:16px;"
            >
              <a-empty style="margin-top:100px;" />
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import { getMatchWarningKeyWordConversationList } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import LabelModal from '../customer/LabelModal.vue';
import moment from 'moment';
export default {
  name: 'RoomList',
  mixins: [JeecgListMixin],
  components: {},
  data() {
    return {
      description: '这是消息查看页面',
      roomid: '',
      recycleBinVisible: false,
      columns: [
        {
          title: 'MsgId',
          align: 'center',
          dataIndex: 'msgid',
          width: 120,
          sorter: true
        },
        {
          title: '消息序号',
          align: 'center',
          width: 100,
          dataIndex: 'seq'
        },
        {
          title: '动作',
          align: 'center',
          width: 100,
          dataIndex: 'action'
        },
        {
          title: '发送人',
          align: 'center',
          width: 80,
          dataIndex: 'msgfrom',
          sorter: true
        },
        {
          title: '群ID',
          align: 'center',
          width: 100,
          dataIndex: 'roomid'
        },
        {
          title: '发送时间',
          align: 'center',
          width: 100,
          dataIndex: 'msgtime'
        },
        {
          title: '消息类型',
          align: 'center',
          width: 100,
          dataIndex: 'msgtype'
        },
        {
          title: '消息内容',
          align: 'center',
          width: 100,
          dataIndex: 'msgcontent',
          customRender: function(text, record, index) {
            let textObj = JSON.parse(text);
            if (record.msgtype === 'text') {
              return textObj.content;
            } else if (record.msgtype === 'chatrecord') {
              return textObj.title;
            } else if (record.msgtype === 'image') {
              return textObj.filesize;
            } else if (record.msgtype === 'link') {
              return textObj.title;
            } else if (record.msgtype === 'weapp') {
              return textObj.title;
            } else if (record.msgtype === 'file') {
              return textObj.filename;
            } else if (record.msgtype === 'location') {
              return textObj.address;
            } else if (record.msgtype === 'card') {
              return textObj.corpname;
            } else if (record.msgtype === 'emotion') {
              return textObj.imagesize;
            } else {
              return text;
            }
          }
        }
      ],
      searchInfo: '',
      conditionDate: null,
      conditionDateStr: '',
      chatInfo: [],
      isactive: 0,
      isactiveRoom: -1,
      current: 1,
      msgfrom: '',
      loadshow: false,
      pageSize: 10,
      noData: false,
      chattotal: '', // 当前群聊消息总条数
      roomId: '', // 群聊id
      chatType: 3, // 群聊个人聊天区别  1 个人 2 群聊
      userId1: '',
      userId2: '',
      score: '',
      activeScore: -1,
      sensitive: '',
      sentiment: '',
      value1: '',
      aboutChatmsgshow: true,
      aboutChatmsg: [],
      fileData: [],
      imgData: [],
      urlData: [],
      chatItem: '',
      chatIndex: '',
      dataTime: [],
      aboutparams: {
        pageNo: 1,
        pageSize: 10
      },
      chatRes: {
        msgPerList: [],
        msgPerRoomList: []
      },
      querparams: {},
      isSearching: false,
      url: {
        // score: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/irs/rating',
        // privateChatList: process.env.VUE_APP_CMS_CHATDATA + '/conversation/privateChatList',
        // roomChatList: process.env.VUE_APP_CMS_CHATDATA + '/conversation/roomChatList',
        // chatData: process.env.VUE_APP_CMS_CHATDATA + '/conversation/chatData',
        score: process.env.VUE_APP_CMS_WECHATWORK + '/wechatwork/irs/rating',
        privateChatList:
          process.env.VUE_APP_CMS_CHATDATA + '/conversation/getChatList',
        roomChatList:
          process.env.VUE_APP_CMS_CHATDATA + '/conversation/getChatList',
        chatData: process.env.VUE_APP_CMS_CHATDATA + '/conversation/chatData',
        queryChatList:
          process.env.VUE_APP_CMS_CHATDATA +
          '/conversation/queryChatListByCondition',
        queryCurrentPageMessagesByMessageId:
          process.env.VUE_APP_CMS_CHATDATA +
          '/conversation/queryCurrentPageMessagesByMessageId'
      },
      // baseurl: 'http://aresoft.ngrok.aresoft.com/middle-platform-gateway/' + process.env.VUE_APP_CMS_CHATDATA +
      //   '/conversation/downloadChatData?sdkfileid=',
      baseurl:
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_CHATDATA +
        '/conversation/downloadChatData?sdkfileid=',
      msgContent: '',
      pages: null,
      condition: '',
      isLoad: true,
      pageMin: null,
      pageMax: null,
      activeKey: '1'
    };
  },
  computed: {
    importExcelUrl: function() {
      return `${process.env.GATEWAY + process.env.VUE_APP_CMS_SYSTEM}/${
        this.url.importExcelUrl
      }`;
    }
  },
  watch: {
    dataSource: function() {
      let item = this.dataSource[0];
      this.chatinfoDetails(item, 0);
    }
  },
  methods: {
    tabChange(activeKey) {
      console.log(activeKey);
      console.log(this.imgData);
      this.activeKey = activeKey;
    },
    onScrollSearch() {
      // console.log(1111);
      var aboutChatMessage = document.getElementById('aboutChatMessage');
      // 获取距离顶部的距离
      var scrollTop = aboutChatMessage.scrollTop;
      // 获取可视区的高度
      var windowHeight = aboutChatMessage.clientHeight;
      // 获取滚动条的总高度
      var scrollHeight = aboutChatMessage.scrollHeight;
      if (scrollTop + windowHeight >= scrollHeight) {
        this.loadshow = true;
        let pageSize = (this.pageSize += 10);
        this.aboutparams.pageSize = pageSize;
        // console.log(pageSize);
        if (this.pages > 0) {
          this.searchQuery();
        }
      }
    },
    //微信客户查看会话
    searchchatfromwx() {
      this.condition = this.$route.query.condition;
      this.onSearchGroup();
    },
    onSearchGroup() {
      //搜索群聊
      this.isSearching = true;
      this.isLoad = false;
      getAction(this.url.queryChatList, {
        pageSize: 10,
        pageNo: this.ipagination.current,
        condition: this.condition
      }).then(res => {
        // console.log(res, 3333);
        if (res.code == 0) {
          this.dataSource = res.result.list;
          this.ipagination.total = res.result.total;
          this.isSearching = false;
        } else {
          this.dataSource = [];
        }
      });
    },
    getWarningKeyWordList() {
      this.isSearching = true;
      this.isLoad = false;
      this.searchInfo = this.$route.query.warningStr;
      getMatchWarningKeyWordConversationList({
        warningId: this.$route.query.warningId
      }).then(res => {
        if (res.success) {
          if (res.result) {
            this.dataSource = res.result;
            this.ipagination.total = res.result.length;
          }
          this.isSearching = false;
        } else {
          this.isSearching = false;
          this.dataSource = [];
        }
      });
    },
    onSearchMember() {
      //搜索联系人
      this.isLoad = false;
      getAction(this.url.queryChatList, {
        pageSize: 1000000,
        pageNo: this.ipagination.current,
        condition: this.condition
      }).then(res => {
        if (res.code == 0) {
          this.chatRes.msgPerList = res.result.list;
          this.isSearching = false;
        } else {
          this.chatRes.msgPerList = [];
          this.isSearching = false;
        }
      });
    },
    onSearchMemberGroup() {
      //搜索成员群聊
      this.isLoad = false;
      getAction(this.url.queryChatList, {
        pageSize: 1000000,
        pageNo: this.ipagination.current,
        condition: this.condition
      }).then(res => {
        if (res.code == 0) {
          this.chatRes.msgPerRoomList = res.result.list;
          this.isSearching = false;
        } else {
          this.chatRes.msgPerRoomList = [];
          this.isSearching = false;
        }
      });
    },
    loadData(value) {
      this.loading = true;
      this.isSearching = true;
      this.roomId = this.$route.query.roomId;
      this.userId2 = this.$route.query.userId;
      this.msgContent = this.$route.query.msgContent;
      let url = '';
      let params = {};
      if (this.roomId || this.$route.query.type) {
        // 执行具体到某一个群聊
        if (this.$route.query.type == 1) {
          params = {
            userId: this.userId2,
            pageSize: 10000000 //获取全部联系人数据
          };
        } else {
          params = {
            userId: this.userId2
          };
        }

        if (this.userId2) {
          this.condition = this.$route.query.userName;
          // 私聊
          getAction(this.url.privateChatList, params).then(res => {
            this.loading = false;
            this.isSearching = false;
            if (res.success) {
              this.dataSource = res.result.list;
            } else {
              this.$message.error(res.message);
            }
          });
        }

        this.chatType = this.$route.query.type;
      } else {
        // 展示全部群聊
        this.chatType = 3;
      }
      // 群聊
      if (this.chatType == 1) {
        params = {
          roomId: this.roomId,
          userId: this.userId2,
          pageNo: this.ipagination.current,
          msgContent: this.msgContent,
          pageSize: 10000000 //获取全部群聊数据
        };
      } else {
        params = {
          roomId: this.roomId,
          userId: this.userId2,
          pageNo: this.ipagination.current,
          msgContent: this.msgContent,
          pageSize: 10
        };
      }
      getAction(this.url.roomChatList, params).then(res => {
        this.loading = false;
        this.isSearching = false;
        if (res.success) {
          if (this.chatType == 1) {
            this.chatRes.msgPerRoomList = res.result.list;
          } else {
            this.dataSource = res.result.list;
            this.ipagination.total = res.result.total;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // getAvatarView: function(avatar) {
    //   return getFileAccessHttpUrl(avatar)
    // },
    // 消息类型

    // paramsInit() {
    //   // 群聊跳转
    //   // 1 个人 2 群聊 3 默认全部群聊
    //   this.chatParam.chatType = 3
    //   if (this.$route.query && this.$route.query.type == 2) {
    //     this.chatParam.roomId = this.$route.query.roomId
    //     this.chatParam.chatType = this.$route.query.type
    //   } else if (this.$route.query && this.$route.query.type == 1) {
    //     // 个人聊天跳转
    //     this.chatParam.userId = this.$route.query.id
    //     this.chatParam.chatType = this.$route.query.type
    //   }else if (this.$route.query && this.$route.query.type == 4) {
    //     // 个人聊天跳转
    //     this.chatParam.chatType = 1
    //     this.chatType = 1
    //     this.chatParam.userId = ''
    //     if(this.searchInfo){
    //       this.chatParam.msgContent = this.searchInfo
    //     } else {
    //       this.chatParam.msgContent = this.$route.query.msgContent
    //     }

    //   }
    // },
    // resetparamsInit() {
    //   // 群聊跳转
    //   this.aboutChatmsgshow = true
    //   this.searchInfo = ''
    //   // 1 个人 2 群聊 3 默认全部群聊
    //   this.chatParam.chatType = 3
    //   if (this.$route.query && this.$route.query.type == 2) {
    //     this.chatParam.roomId = this.$route.query.id
    //     this.chatParam.chatType = this.$route.query.type
    //   } else if (this.$route.query && this.$route.query.type == 1) {
    //     // 个人聊天跳转
    //     this.chatParam.userId = this.$route.query.id
    //     this.chatParam.chatType = this.$route.query.type
    //   }else if (this.$route.query && this.$route.query.type == 4) {
    //     // 个人聊天跳转
    //     this.chatParam.chatType = 1
    //     this.chatType = 1
    //     this.chatParam.userId = ''

    //   }
    // },

    // 消息重置
    messageReset() {
      const that = this;
      that.searchInfo = '';
      this.conditionDate = null;
      this.conditionDateStr = '';
      this.chatinfoDetails(this.chatItem, this.chatIndex);
    },

    // 点击消息列表查看具体的信息
    chatinfoDetails(item, index) {
      console.log(item, index);
      if (!item) {
        this.$message.warning('请先选择聊天');
        return;
      }
      this.chatItem = item;
      this.chatIndex = index;
      // this.aboutChatmsgshow = true
      this.isactive = index;
      this.chatType = item.chatType;
      this.msgfrom = item.title || item.roomName || item.ownerName + '的群';
      this.activeKey = '1';
      this.conditionDate = null;
      this.searchInfo = null;
      // if(this.$route.query.type == 4){
      //   this.chatType = 1
      // } else {
      //   this.chatType = this.$route.query.type || 2
      // }

      var params = {
        pageNo: 1,
        pageSize: 10,
        chatType: this.chatType
      };
      this.userId1 = item.receiveId;
      // this.userId2 = this.userId2
      // 1 个人 2 群聊 3 全部群聊
      if (item.chatType == 2) {
        // 2 群聊 3 全部群聊
        params.roomId = item.roomId;
        this.roomId = item.roomId;
      } else {
        params.userId1 = item.receiveId;
        params.userId2 = item.sendId || this.$route.query.userId; // 接受人
        this.userId2 = params.userId2;
      }

      // } else{
      this.roomId = item.roomId || this.roomId;

      // }
      // 每次清空一下 各种类型的数据
      this.imgData = [];
      this.fileData = [];
      this.urlData = [];
      this.searchChat(params);
    },
    // 销售列表 - 群聊
    groupinfo(item, index) {
      // this.aboutChatmsgshow = true
      this.isactiveRoom = index;
      this.msgfrom = item.roomName || item.ownerName;
      this.roomId = item.roomId;
      this.chatType = 2;
      var params = {
        pageNo: 1,
        pageSize: 10,
        chatType: this.chatType,
        roomId: this.roomId
      };
      // 每次清空一下 各种类型的数据
      this.imgData = [];
      this.fileData = [];
      this.urlData = [];
      getAction(this.url.chatData, params).then(res => {
        console.log(111);
        if (res.code === 0) {
          this.chatInfo = res.result.list;
          this.handleData(this.chatInfo);
          // this.chatInfo.forEach(item => {
          //   switch (item.msgtype) {
          //     case 'image':
          //       this.imgData.push(item)
          //       break
          //     case 'file':
          //       this.fileData.push(item)
          //       break
          //     case 'link':
          //       this.urlData.push(item)
          //       break
          //     default:
          //       break
          //   }
          // })
          this.chattotal = item.num;
        }
        if (res.code === 500) {
          this.$notification['error']({
            message: '获取失败',
            description: res.message
          });
        }
        this.loadshow = false;
      });
    },

    change(current) {
      console.log(current);
      this.ipagination.current = current;
      this.loadData();
    },
    changeGroupList(current) {
      this.ipagination.current = current;
      this.onSearchGroup();
      // this.loadData()
    },
    // 获取第一条数据
    // firstDatafn() {
    //   if(this.$route.query.type == 4){
    //     this.chatType = 1
    //   }
    //   var params = {
    //     pageNo: 1,
    //     pageSize: 10,
    //     chatType: this.chatType
    //   }
    //   // 1 个人 2 群聊 3 所有群聊
    //   if (this.chatType == 1 && this.chatRes.msgPerList.length) {
    //     params.userId1 = this.chatRes.msgPerList[0].owner
    //     params.userId2 = this.chatRes.msgPerList[0].name
    //   } else if (this.chatType == 2) {
    //     params.roomId = this.roomId
    //   }
    //   this.msgfrom = this.chatRes.msgPerList[0].extUserName
    //   getAction(this.url.chatData, params).then(res => {
    //     if (res.code === 0) {
    //       this.chatInfo = res.result.list
    //       console.log(this.chatInfo);
    //       this.chattotal = res.result.total
    //       this.isactive = 0
    //     }
    //     if (res.code === 500) {
    //       this.$notification['error']({
    //         message: '获取失败',
    //         description: res.message
    //       })
    //     }
    //   })
    // },
    // 时间戳转换格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-';
      var D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':';
      var s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 获取当前语句评分
    scoreView(msg, index) {
      postAction(this.url.score, {
        msg: msg
      }).then(res => {
        if (res.code === 200) {
          this.score = res.result.score;
          this.sensitive = res.result.sensitive;
          this.sentiment = res.result.sentiment;
          this.activeScore = index;
        }
      });
    },
    // 判断聊天信息的主次视角
    msgcurrent(msgfrom) {
      if (msgfrom === this.$route.query.id) {
        return 'currentuser';
      } else {
        return 'otheruser';
      }
    },
    // 搜索
    searchQuery() {
      // if(this.searchInfo===''&&this.conditionDateStr==='') {
      //     this.$message.error('请输入查询条件')
      //     return false
      // }
      if (!this.searchInfo && !this.conditionDateStr) {
        // this.aboutChatmsgshow = true
        let params = {
          pageNo: 1,
          pageSize: 10,
          chatType: this.chatType
        };

        console.log(params);
        // this.userId2 = this.userId2
        // 1 个人 2 群聊 3 全部群聊
        if (this.chatType == 2) {
          // 2 群聊 3 全部群聊
          params.roomId = this.roomId || '';
        } else {
          params.userId1 = this.userId1 || '';
          params.userId2 = this.userId2 || ''; // 接受人
        }
        // }
        // 每次清空一下 各种类型的数据
        this.imgData = [];
        this.fileData = [];
        this.urlData = [];
        this.searchChat(params);
        return;
      }

      this.pages = 1;
      // this.aboutChatmsgshow = false
      this.aboutparams.chatType = this.chatType;
      let userId1 = this.userId1;
      let userId2 = this.userId2;
      // 1 个人 2 群聊 3 所有群聊
      // if (this.chatType == 1 && this.chatRes.msgPerList.length) {
      //     this.aboutparams.userId1 = userId1
      //     this.aboutparams.userId2 = userId2
      // } else if (this.chatType == 2) {
      //     this.aboutparams.roomId = this.roomId
      // } else {
      //     this.aboutparams.roomId = this.roomId
      // }
      if (this.chatType == 2) {
        this.aboutparams.roomId = this.roomId;
      } else {
        this.aboutparams.userId1 = userId1;
        this.aboutparams.userId2 = userId2;
      }
      this.aboutparams.msgContent = this.searchInfo;

      // this.aboutparams.conditionDate = '2021-01-25 - 2021-01-25'
      this.aboutparams.conditionDate = this.conditionDateStr;
      this.imgData = [];
      this.fileData = [];
      this.urlData = [];
      this.chatInfo = [];
      getAction(this.url.chatData, this.aboutparams).then(res => {
        this.chatInfo = res.result.list;
        this.loadshow = false;
        if (this.chatInfo && this.chatInfo.length > 0) {
          this.handleData(this.chatInfo);
        } else {
          this.imgData = [];
          this.fileData = [];
          this.fileData = [];
        }
      });
    },
    // 重置
    searchReset() {
      this.searchInfo = '';
      this.conditionDate = null;
      this.conditionDateStr = '';
    },
    goSearch(id) {
      this.loading = true;
      // this.aboutChatmsgshow = true
      getAction(this.url.queryCurrentPageMessagesByMessageId, {
        msgId: id
      }).then(res => {
        if (res.code === 0) {
          this.chatInfo = res.result.messages;
          this.pages = res.result.currentPage;
          this.pageMax = res.result.currentPage + 1;
        }
        if (res.code === 510) {
          this.$message.error(res.message);
        }
        this.loading = falsey;
      });
    },
    changeTime(time, time1) {
      let presentTime = moment(time1[1])
        .add(1, 'days')
        .format('YYYY-MM-DD');
      if (time1[0] == '' && time1[1] == '') {
        this.conditionDateStr = '';
      } else {
        this.conditionDateStr = time1[0] + '_' + presentTime;
      }
    },
    searchChat(params) {
      getAction(this.url.chatData, params).then(res => {
        if (res.code === 0) {
          // if (res.result.pages != 0) {
          //   this.pages = res.result.pages
          //   params.pageNo = this.pages
          //   this.loadshow = false
          // } else {
          //   console.log(444)
          //   this.chatInfo = res.result.list
          //   this.loadshow = false
          //   return false
          // }
          this.chatInfo = res.result.list;
          this.loadshow = false;
          this.pages = res.result.pages;
          params.pageNo = this.pages;
          if (this.chatInfo && this.chatInfo.length == res.result.total) {
            this.loadshow = false;
            return;
          }
          getAction(this.url.chatData, params).then(res1 => {
            // this.chatInfo = res1.result.list
            let arr = res1.result.list;
            console.log(res1.result.list);
            if (res1.result.list.length > 10) {
              this.loadshow = true;
              // let pageSize = (this.pageSize += 10)
              if (this.pages >= 0) {
                this.pages--;
              }
              var params = {
                pageNo: this.pages,
                pageSize: 10,
                chatType: this.chatType
              };
              // 1 个人 2 群聊
              if (this.chatType == 1) {
                params.userId1 =
                  this.userId1 || this.chatRes.msgPerList[0].owner;
                params.userId2 =
                  this.userId2 || this.chatRes.msgPerList[0].name;
              } else {
                params.roomId = this.roomId;
              }

              if (arr && arr == res1.result.total) {
                this.chatInfo = this.chatInfo.concat(arr);
                this.loadshow = false;
                return;
              }
              getAction(this.url.chatData, params).then(res2 => {
                if (res2.code === 0) {
                  // if (pageSize <= res2.result.total) {
                  //     this.chatInfo = res2.result.list
                  //     this.loadshow = false
                  // } else {
                  //     this.loadshow = false
                  //     this.noData = true
                  // }
                  this.chatInfo = res2.result.list;
                  this.chatInfo = this.chatInfo.concat(arr);
                  this.$nextTick(() => {
                    var div = document.getElementById('message');
                    div.scrollTop = div.scrollHeight;
                  });
                }
                this.imgData = [];
                this.fileData = [];
                this.fileData = [];
                this.handleData(this.chatInfo);
                // this.chatInfo.forEach(item => {
                //   switch (item.msgtype) {
                //     case 'image':
                //       this.imgData.push(item)
                //       break
                //     case 'file':
                //       this.fileData.push(item)
                //       break
                //     case 'link':
                //       this.urlData.push(item)
                //       break
                //     default:
                //       break
                //   }
                // })
                this.loadshow = false;
              });
            } else {
              this.chatInfo = arr;
              this.$nextTick(() => {
                var div = document.getElementById('message');
                div.scrollTop = div.scrollHeight;
              });
            }
          });

          // this.chattotal = item.num //  单聊 没有
        }
        if (res.code === 500) {
          this.$notification['error']({
            message: '获取失败',
            description: res.message
          });
        }
        this.loadshow = false;
      });
    },
    upScrollFn() {
      var message = document.getElementById('message');
      // 获取距离顶部的距离
      var scrollTop = message.scrollTop;
      // 获取可视区的高度
      var windowHeight = message.clientHeight;
      // 获取滚动条的总高度
      var scrollHeight = message.scrollHeight;
      // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
      // if (scrollTop + windowHeight >= scrollHeight) {
      if (scrollTop == 0) {
        this.loadshow = true;
        // let pageSize = (this.pageSize += 10)
        if (this.pages > 1) {
          this.pages--;
        } else {
          return;
        }
        var params = {
          pageNo: this.pages,
          pageSize: 10,
          chatType: this.chatType
        };
        // 1 个人 2 群聊
        if (this.chatType == 1) {
          params.userId1 = this.userId1 || this.chatRes.msgPerList[0].owner;
          params.userId2 = this.userId2 || this.chatRes.msgPerList[0].name;
        } else {
          params.roomId = this.roomId;
        }
        getAction(this.url.chatData, params).then(res => {
          console.log(666);
          if (res.code === 0) {
            // if (pageSize <= res.result.total) {
            //     this.chatInfo = res.result.list
            //     this.loadshow = false
            // } else {
            //     this.loadshow = false
            //     this.noData = true
            // }
            console.log(777);
            this.chatInfo = res.result.list.concat(this.chatInfo);
            this.$nextTick(() => {
              var div = document.getElementById('message');
              div.scrollTop = div.clientHeight;
            });
            this.loadshow = false;
          }
        });
        this.loadshow = false;
      } else if (scrollTop + windowHeight >= scrollHeight && this.pageMax) {
        // 把距离顶部的距离加上可视区域的高度 等于或者大于滚动条的总高度就是到达底部
        this.loadshow = true;
        this.pageMax++;
        var params = {
          pageNo: this.pageMax,
          pageSize: 10,
          chatType: this.chatType
        };
        // 1 个人 2 群聊
        if (this.chatType == 1) {
          params.userId1 = this.userId1 || this.chatRes.msgPerList[0].owner;
          params.userId2 = this.userId2 || this.chatRes.msgPerList[0].name;
        } else {
          params.roomId = this.roomId;
        }
        getAction(this.url.chatData, params).then(res => {
          console.log(777);
          if (res.code === 0) {
            console.log(888);
            this.chatInfo = this.chatInfo.concat(res.result.list);
            // this.$nextTick(() => {
            //   var div = document.getElementById('message');
            //   div.scrollTop = div.clientHeight;
            // })
            this.loadshow = false;
          }
        });
        this.loadshow = false;
      } else {
        this.loadshow = false;
      }
    },
    handleData(arr) {
      arr.forEach(item => {
        switch (item.msgtype) {
          case 'image':
          case 'video':
            this.imgData.push(item);
            break;
          // case 'video':
          //   this.getMediaList(item.sdkfileid);
          //   break;
          case 'file':
            this.fileData.push(item);
            break;
          case 'link':
            this.urlData.push(item);
            break;
          default:
            break;
        }
      });
    }
  },
  mounted() {
    // 微信客户跳转搜索聊天
    if (this.$route.query.condition) {
      this.searchchatfromwx();
    }
    if (this.$route.query.warningId || this.$route.query.warningStr) {
      this.getWarningKeyWordList();
    }
  }
  // mounted () {
  //     setTimeout(() => {
  //         this.$nextTick(() => {
  //             // 进入nexTick
  //             var message = document.getElementById('message') // 获取滚动条的dom
  //             // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
  //             message.onscroll = () =>

  //             // if(!this.aboutChatmsgshow) {
  //             //   var aboutChatMessage = document.getElementById('aboutChatMessage')
  //             //   aboutChatMessage.onscroll = () => {
  //             //     // 获取距离顶部的距离
  //             //     var scrollTop = aboutChatMessage.scrollTop
  //             //     // 获取可视区的高度
  //             //     var windowHeight = aboutChatMessage.clientHeight
  //             //     // 获取滚动条的总高度
  //             //     var scrollHeight = aboutChatMessage.scrollHeight
  //             //     if (scrollTop + windowHeight >= scrollHeight) {
  //             //       this.loadshow = true
  //             //       let pageSize = (this.pageSize += 10)
  //             //       this.aboutparams.pageSize = pageSize
  //             //       this.searchQuery()
  //             //     }
  //             //   }
  //             // }
  //         })
  //     }, 2000)
  // }
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style scoped lang="less">
ul,
li {
  list-style: none;
  margin: 0;
}
.ant-card /deep/ .ant-card-body {
  padding: 0;
  height: 100%;
}

.ant-card {
  background: none !important;
}

.ant-card /deep/ .ant-input-group-wrapper {
  vertical-align: middle;
  width: 70%;
}

.ant-card /deep/ .ant-input-group-wrapper {
  width: 55%;
}
.chatList-left {
  width: 320px;
  height: 100%;
  border-right: 1px #f5f5f5 solid;
  background: #fff;
  display: flex;
  flex-direction: column;
  .searchtop {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    border-bottom: 1px solid #ddd;
    span {
      margin-left: 20px;
    }
    input {
      width: 60%;
      height: 40px;
      border: 1px #ccc solid;
      border-radius: 30px;
      margin-left: 20px;
      padding: 20px;
      outline: none;
      background: rgb(232, 235, 238);
    }
  }
  .list-content {
    flex: 1;
    overflow: auto;
    ul {
      width: 100%;
      padding-inline-start: 0;
      padding-inline-end: 0;
    }
    ul li {
      width: 100%;
      height: 72px;
      border-bottom: 1px solid #f7f7f7;
      padding: 10px 20px;
      box-sizing: border-box;
      cursor: pointer;
    }
    ul li div {
      margin-left: 60px;
    }
    ul li img {
      width: 40px;
      height: 40px;
      float: left;
      margin-top: 6px;
      border-radius: 50%;
    }
    ul li p {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 240px;
      display: inline-block;
      margin: 0;
      font-size: 16px;
      color: #161616bd;
    }
    ul li span {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 240px;
      display: inline-block;
      color: #333;
    }
  }
}
.aboutList {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 10px 100px 0;
  overflow-y: auto;
  background: #fff;
  ul li {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    height: 80px;
    border-bottom: 1px #ccc solid;
    margin-top: 20px;
    overflow: hidden;
    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      float: left;
      margin-right: 20px;
    }
  }
  ul li:hover {
    background: rgb(205, 205, 205);
  }
}
.chatList-right {
  flex: 1;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  box-sizing: border-box;
  max-width: 72%;
  .headerOfuser {
    width: 100%;
    height: 100px;
    padding-top: 20px;
    box-sizing: border-box;
  }
  .message {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 10px 100px 0;
    overflow-y: auto;
    div:nth-child(1) {
      margin-top: 10px;
    }

    .content {
      margin-top: 30px;
    }
    .currentuser {
      position: relative;
      margin-top: 35px;
      img {
        width: 40px;
        height: 40px;
        float: right;
        margin-top: 30px;
        margin-right: 20px;
        border-radius: 50%;
      }
      span {
        margin-right: 20px;
        background: rgb(134, 236, 87);
        display: inline-block;
        line-height: 40px;
        font-size: 16px;
        padding: 0 20px;
        max-width: 600px;
        word-wrap: break-word;
        word-break: break-all;
        border-radius: 10px;
        position: relative;
        user-select: none;
        color: black;
        margin-top: 30px;
      }
      span::after {
        content: '';
        position: absolute;
        right: -15px;
        top: 11px;
        border: 8px solid transparent;
        border-left-color: rgb(134, 236, 87);
      }
      b {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        right: 55px;
        margin-right: 30px;
        i {
          margin: 3px 4px;
        }
      }
      em {
        position: absolute;
        right: 85px;
        font-size: 16px;
        bottom: -30px;
      }
    }
  }
  .filecontainer {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 10px 100px 0;
    overflow-y: auto;

    ul li {
      padding: 20px;
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      border-bottom: 1px #ccc solid;
      margin-top: 20px;
      div:nth-child(1) {
        margin-top: 10px;
      }
    }
  }
  .imgcontainer {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0 10px 100px 0;
    overflow-y: auto;
    ul {
      display: flex;
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      li {
        width: 100%;
        height: 400px;
        margin-top: 20px;
        img {
          width: 400px;
          margin-left: 20px;
        }
      }
    }
    ul li {
      width: 100%;
      margin-top: 20px;
      div:nth-child(1) {
        margin-top: 10px;
      }
    }
    ul li img {
      width: 200px;
      height: auto;
      margin-left: 20px;
    }
    ul li .touxiang {
      width: 40px;
      height: 40px;
      float: left;
      margin-right: 20px;
      border-radius: 50%;
    }
  }
  .otheruser {
    position: relative;
    padding-top: 35px;
    img {
      width: 40px;
      height: 40px;
      float: left;
      margin-right: 20px;
      border-radius: 50%;
    }
    em {
      position: absolute;
      left: 67px;
      bottom: -30px;
      font-size: 16px;
    }
    span {
      display: inline-block;
      background: #ccc;
      line-height: 40px;
      font-size: 16px;
      padding: 0 20px;
      max-width: 600px;
      word-wrap: break-word;
      word-break: break-all;
      border-radius: 10px;
      position: relative;
      user-select: none;
      color: black;
    }
  }
  .otheruser > span::after {
    content: '';
    position: absolute;
    left: -16px;
    top: 11px;
    border: 8px solid transparent;
    border-right-color: #ccc;
  }
}
.chatList-right /deep/ .ant-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.chatList-right /deep/ .ant-tabs-bar {
  margin: 0;
}
.chatList-right /deep/ .ant-tabs-content {
  flex: 1;
  height: 100%;
}
.chatList-right /deep/ .ant-tabs-content .ant-tabs-tabpane {
  overflow: auto;
}

.list-content::-webkit-scrollbar,
.message::-webkit-scrollbar,
.chatList-right /deep/ .ant-tabs-content .ant-tabs-tabpane::-webkit-scrollbar {
  width: 3px;
  height: 1px;
}
.active {
  background: #dedede;
}
.nullchat {
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
  font-size: 14px;
  font-weight: 400;
}
</style>
<style scoped>
#message >>> em {
  color: #e04141;
  font-style: normal;
}

#message.no-em-css >>> em {
  color: #000;
}
</style>
